import { getApiClient } from "@src/api";
import { graphql } from "@src/gql/gql";
import { useMutation } from "@tanstack/react-query";
const revokePermissionQuery = graphql(/* GraphQL */ `
	mutation revokePermissions($whiteboardId: String!, $userEmail: String!) {
		whiteboards {
			revokePermission(whiteboardId: $whiteboardId, userEmail: $userEmail) {
				status
				name
				ownerId
			}
		}
	}
`);

/**
 * Revoke permission for a user on a whiteboard.
 *
 * @returns React Query mutation object
 */
export const useRevokeWhiteboardPermission = () => {
	const client = getApiClient();

	return useMutation({
		mutationFn: async ({
			whiteboardId,
			userEmail,
		}: {
			whiteboardId: string;
			userEmail: string;
		}) => {
			const result = await client.mutate({
				mutation: revokePermissionQuery,
				variables: {
					whiteboardId,
					userEmail,
				},
			});

			return result.data;
		},
	});
};
